import React from 'react';
import {Location} from "history";
import {SchemaContextProvider} from "../../components/schema/context/SchemaContext";
import {getQueryParam} from "../../utils/location-utils";
import ContentBlocker from "../../components/context/ContentBlocker";
import ObjectDetails from "../../components/object/ObjectDetails";

type ObjectViewPageProps = {
  location: Location;
};

type ObjectViewPageState = {
  objectId: string
}

/**
 * Helper method to construct relative URL for the view page for specific object.
 *
 * @param {string} objectId the object identifier that will be opened
 * @returns {string} a relative URL with the object id as query parameter
 */
export function getObjectViewPageUrl(objectId: string) {
  return `/object/view?id=${encodeURIComponent(objectId)}`;
}

/**
 * Page for visualizing object details.
 */
export default class ObjectViewPage extends React.Component<ObjectViewPageProps, ObjectViewPageState> {

  constructor(props: ObjectViewPageProps) {
    super(props);
    this.state = {
      objectId: this.getObjectIdParam()
    };
  }

  componentDidUpdate() {
    const idParam = this.getObjectIdParam();
    if (this.state.objectId !== idParam) {
      this.setState({
        objectId: this.getObjectIdParam()
      });
    }
  }

  getObjectIdParam(): string {
    return getQueryParam(this.props.location, 'id') as string;
  }

  render() {
    return (
      <div className="ObjectViewPage">
        <h1>Object View</h1>
        <ContentBlocker checkReadPermission={true}>
          <SchemaContextProvider loadGraphQlSchema={true}>
            <ObjectDetails id={this.state.objectId}/>
          </SchemaContextProvider>
        </ContentBlocker>
      </div>
    );
  }

}
